import React from "react";
import Icon from "~/Common-Objects/UI/Icon";
import './style.scss';

const VideoModal = ({ video, poster, autoPlay = false, controls = true, height, width, onClose }) => {
    return (
        <div className="video-modal">
            <div className="video-modal__backdrop">
                {onClose && (
                    <button className="video-modal__close-btn" onClick={onClose} postHogTag="close-video-modal">
                        <Icon name="cross" height="24" width="24" />
                    </button>
                )}
                <div className="video-modal__content" style={{ width: width, height: height }}>
                    <video controls={controls} autoPlay={autoPlay} poster={poster}>
                        <source src={video} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    );
}

export default VideoModal;